import React, {Component} from 'react'

import {UserAction} from '../actions/UserAction'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {SearchAction} from "../actions/SearchAction"
import {Collapse} from "reactstrap"
import SearchService from "../services/search.service"
import AuthService from "../services/auth.service"
import {gaEventWithUserIdLabel, izNotEmpty, LOG_OUT, MATCH_RATE_SLIDER_MARKS, minMatchRateFormatter, SEARCH_SUCCESS} from '../constants'
import {Button, Checkbox, Input, message, Radio, Slider, Tabs} from "antd"
import i18n from "i18next"
import {BankOutlined, ClockCircleOutlined, EnvironmentOutlined, IdcardOutlined, UserOutlined} from "@ant-design/icons"

const {TabPane} = Tabs;

const radioStyle = {lineHeight: '30px'}

class Search extends Component {

    constructor(props) {
        super(props)

        this.state = {
            searchButtonLoading: false,
            searchBarSwitch: true,
            recordTypes: ["INDIVIDUAL", "ENTITY", "COUNTRY"],
            activeRecordType: "INDIVIDUAL",
            personNameSwitch: true,
            entityNameSwitch: true,
            searchForm: {
                recordType: "INDIVIDUAL",
                personName: "",
                entityName: "",
                minMatchRate: 80,
                includeLocalSanctions: false,
                includePeP: false,
                includeAdverseMedia: false
            }
        }

        this.props.searchAction(SEARCH_SUCCESS, {})
    }

    toggleRecordType = (recordType) => {
        const {minMatchRate} = this.state.searchForm;

        this.setState(prevState => ({
            activeRecordType: recordType,
            searchForm: {
                ...prevState.searchForm,
                minMatchRate: minMatchRate
            }
        }))
    }

    onSearchToggle = () => {
        this.setState({
            searchBarSwitch: !this.state.searchBarSwitch
        })
    }

    onSearch = e => {

        let searchForm = this.state.searchForm;

        let recordType = this.state.activeRecordType;

        let personName = searchForm.personName;
        let placeOfBirth = searchForm.placeOfBirth;
        let yearOfBirth = searchForm.yearOfBirth;
        let identification = searchForm.identification;

        let entityName = searchForm.entityName;
        let entityAddress = searchForm.entityAddress;
        let entityIdentification = searchForm.entityIdentification;

        let countryName = searchForm.countryName;

        let minMatchRate = searchForm.minMatchRate;
        let includeLocalSanctions = searchForm.includeLocalSanctions;
        let includePeP = searchForm.includePeP;
        let includeAdverseMedia = searchForm.includeAdverseMedia;

        let personNameSwitch = this.state.personNameSwitch;
        let entityNameSwitch = this.state.entityNameSwitch;

        if (recordType === "INDIVIDUAL") {
            if (personNameSwitch === true) {
                if (!personName || personName.trim() === "") {
                    return message.error(i18n.t('error_personName'))
                }
                if (personName.trim().indexOf(" ") <= 0) {
                    return message.error(i18n.t('invalid_personName'))
                }
                if (this.isWordLengthInvalid(personName.trim(), 1) && personName.trim().length < 3) {
                    return message.error(i18n.t('invalid_personName'))
                }

                // if (!placeOfBirth || placeOfBirth.trim() === "") {
                //     return message.error(i18n.t('error_placeOfBirth'))
                // }

                let currentYear = new Date().getFullYear()

                if (yearOfBirth && (yearOfBirth < currentYear - 110 || currentYear - 13 < yearOfBirth)) {
                    return message.error(i18n.t('invalid_yearOfBirth'))
                }
            } else {
                if (!identification || identification.trim() === "") {
                    return message.error(i18n.t('error_identification'))
                }
            }
        } else if (recordType === "ENTITY") {
            if (entityNameSwitch === true) {
                if (!entityName || entityName.trim() === "") {
                    return message.error(i18n.t('error_entityName'))
                }

                if (this.isWordLengthInvalid(entityName.trim(), 1) && entityName.trim().length < 3) {
                    return message.error(i18n.t('invalid_entityName'))
                }
            } else {
                if (!entityIdentification || entityIdentification.trim() === "") {
                    return message.error(i18n.t('error_entityIdentification'))
                }
            }
        } else if (recordType === "COUNTRY") {
            if (!countryName || countryName.trim() === "") {
                return message.error(i18n.t('error_countryName'))
            }
            if (this.isWordLengthInvalid(countryName.trim(), 1) && countryName.trim().length < 3) {
                return message.error(i18n.t('invalid_countryName'))
            }
        } else {
            return message.error(i18n.t('error_entityName'))
        }

        this.setState({searchButtonLoading: true})

        if (this.state.searchBarSwitch) {
            gaEventWithUserIdLabel("SearchService.search Click - " + recordType)
            SearchService.search(recordType, personNameSwitch,
                minMatchRate,
                includeLocalSanctions, includePeP, includeAdverseMedia,
                identification,
                personName, placeOfBirth, yearOfBirth,
                entityName, entityAddress,
                entityNameSwitch, entityIdentification, countryName).then(
                response => {
                    this.setState({searchButtonLoading: false})

                    if (response.data) {
                        const success = response.data.success;
                        if (success) {
                            const {items, additionalMediaLinks} = response.data;

                            let searchResults = items ? items : [];

                            const searchResultPayload = {
                                searchResults: searchResults,
                                includeAdverseMedia: includeAdverseMedia,
                                additionalMediaLinks: additionalMediaLinks ? additionalMediaLinks : []
                            }

                            this.props.searchAction(SEARCH_SUCCESS, searchResultPayload)

                            this.setState({
                                searchBarSwitch: !this.state.searchBarSwitch
                            })
                        } else {
                            if (response.data.errorMessage && response.data.errorMessage === "PACKAGE_OVER") {
                                gaEventWithUserIdLabel("SearchService.search Search Error - " + i18n.t('search_error_package_over'))
                                message.error(i18n.t('search_error_package_over'))
                            } else {
                                gaEventWithUserIdLabel("SearchService.search Search Error - " + i18n.t('search_error'))
                                message.error(i18n.t('search_error'))
                            }
                        }
                    } else {
                        gaEventWithUserIdLabel("SearchService.search Data Error - " + i18n.t('global_error'))
                        message.error(i18n.t('search_error'))
                    }
                },
                error => {
                    this.setState({searchButtonLoading: false})

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("SearchService.search Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
        } else {
            this.setState({
                searchButtonLoading: false,
                searchBarSwitch: !this.state.searchBarSwitch
            })
        }
    }

    isWordLengthInvalid(wholeName, minLength) {
        const names = wholeName.split(" ");

        for (const name of names) {
            if (name.length <= minLength) return true;
        }

        return false;
    }

    handlePersonNameSwitch = e => {
        let checked = e.target.value
        this.setState({
            personNameSwitch: checked
        })
    }

    handleEntityNameSwitch = e => {
        let checked = e.target.value
        this.setState({
            entityNameSwitch: checked
        })
    }

    handleInputChange = (e) => {

        let {name, value} = e.target

        if ("yearOfBirth" === name) {
            value = parseInt(value, 10) ? parseInt(value, 10) : ""
        }

        this.setState(prevState => ({
            searchForm: {
                ...prevState.searchForm,
                [name]: value
            }
        }))
    }

    handleIncludeLocalSanctionsChecked = (e) => {
        this.setState(prevState => ({
            searchForm: {
                ...prevState.searchForm,
                includeLocalSanctions: e.target.checked
            }
        }))
    }

    handleIncludePePChecked = (e) => {
        this.setState(prevState => ({
            searchForm: {
                ...prevState.searchForm,
                includePeP: e.target.checked
            }
        }))
    }

    handleIncludeAdverseMedia = (e) => {
        this.setState(prevState => ({
            searchForm: {
                ...prevState.searchForm,
                includeAdverseMedia: e.target.checked
            }
        }))
    }

    handleMinMatchRate = (minMatchRate) => {
        this.setState(prevState => ({
            searchForm: {
                ...prevState.searchForm,
                minMatchRate: minMatchRate
            }
        }))
    }

    render() {

        const {activeRecordType, recordTypes, searchButtonLoading} = this.state
        const {searchResults} = this.props.search;

        return (
            <>
                <section>
                    <div id="searchPanel" className="container search-tab custom-card-border">
                        <Collapse isOpen={this.state.searchBarSwitch}>

                            <div className="custom-ant-input-wrapper">
                                <Tabs defaultActiveKey={activeRecordType} onChange={this.toggleRecordType} destroyInactiveTabPane={false}>
                                    {recordTypes.filter(type => !(type === "COUNTRY" && !AuthService.hasRole("COUNTRY_SEARCH"))).map((type) => (

                                        <TabPane tab={i18n.t('record_type_' + type)} key={type}>
                                            {type === "INDIVIDUAL" && this.searchByIndividual()}
                                            {type === "ENTITY" && this.searchByEntity()}
                                            {type === "COUNTRY" && this.searchByCountry()}
                                        </TabPane>

                                    ))}
                                </Tabs>

                            </div>

                            <div className="d-flex justify-content-center search-panel-button mt-25">
                                <Button
                                    className="custom-button"
                                    onClick={this.onSearch}
                                    loading={searchButtonLoading}>
                                    <i className="fa fa-search"/>
                                    {i18n.t('search')}
                                </Button>
                            </div>
                        </Collapse>

                        <Collapse isOpen={!this.state.searchBarSwitch} className="searchPanelSecondCollapse">
                            <div className="row justify-content-center">
                                <div className="result-label">
                                    {izNotEmpty(searchResults) ?
                                        <span>
                                            {i18n.t('search_result_one')}
                                            <strong>{searchResults.length}</strong>
                                            {i18n.t('search_result_second')}
                                        </span>
                                        : this.state.searchForm.includePeP ?
                                            <span>
                                                {i18n.t('search_not_fount')}
                                            </span> : <span>
                                                {i18n.t('search_not_fount_exclude_pep')}
                                            </span>
                                    }
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <Button
                                    className="custom-button"
                                    onClick={this.onSearchToggle}>
                                    <i className="fa fa-search"/>
                                    {i18n.t('new_search')}
                                </Button>
                            </div>
                        </Collapse>

                    </div>
                </section>
            </>
        )
    }

    searchByCountry() {

        const showCountrySearch = AuthService.hasRole("COUNTRY_SEARCH");

        if (!showCountrySearch) {
            return
        }

        const {searchForm} = this.state
        const {minMatchRate} = searchForm;

        return <>

            <Input
                className="country-name-input"
                placeholder={i18n.t('country_name')}
                prefix={<BankOutlined/>}
                name="countryName"
                autoComplete="off"
                onChange={this.handleInputChange}
                value={this.state.searchForm.countryName}
            />

            <div className="row search-param-row">
                <div className="col-sm-12 col-md-4 search-param-label">
                    <span>{i18n.t('minMatchRate')}</span>
                </div>
                <div className="col-sm-12 col-md-8">
                    <Slider
                        min={60} max={100}
                        value={minMatchRate}
                        defaultValue={minMatchRate}
                        marks={MATCH_RATE_SLIDER_MARKS}
                        onChange={this.handleMinMatchRate}
                        tipFormatter={minMatchRateFormatter}
                    />
                </div>
            </div>


        </>;
    }

    searchByEntity() {

        const {searchForm} = this.state
        const {minMatchRate, includeAdverseMedia} = searchForm;
        const showAdverseMedia = AuthService.hasRole("ADVERSE_MEDIA");

        return <>
            <div className="mt-20 mb-20">
                <Radio.Group onChange={this.handleEntityNameSwitch} value={this.state.entityNameSwitch}>
                    <Radio style={radioStyle} value={true}>
                        {i18n.t('search_by_entity_name')}
                    </Radio>
                    <Radio style={radioStyle} value={false}>
                        {i18n.t('search_by_entity_id')}
                    </Radio>
                </Radio.Group>
            </div>

            <Collapse isOpen={this.state.entityNameSwitch}>

                <Input
                    placeholder={i18n.t('entity_name')}
                    prefix={<BankOutlined/>}
                    name="entityName"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.entityName}
                />

                <Input
                    placeholder={i18n.t('entityAddress')}
                    prefix={<EnvironmentOutlined/>}
                    autoComplete="off"
                    name="entityAddress"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.entityAddress}
                />

                <div className="row search-param-row">
                    <div className="col-sm-12 col-md-4 search-param-label">
                        <span>{i18n.t('minMatchRate')}</span>
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <Slider
                            min={60} max={100}
                            value={minMatchRate}
                            defaultValue={minMatchRate}
                            marks={MATCH_RATE_SLIDER_MARKS}
                            onChange={this.handleMinMatchRate}
                            tipFormatter={minMatchRateFormatter}
                        />
                    </div>
                </div>

                {showAdverseMedia && <div className="row search-param-row">
                    <div className="col-8 col-md-4 search-param-label">
                        <label htmlFor="includeAdverseMediaForEntity">{i18n.t('includeAdverseMedia')}</label>
                    </div>
                    <div className="col-4 col-md-8">
                        <Checkbox
                            id="includeAdverseMediaForEntity"
                            name="includeAdverseMediaForEntity"
                            size="large"
                            checked={includeAdverseMedia}
                            onChange={this.handleIncludeAdverseMedia}
                        />
                    </div>
                </div>
                }

            </Collapse>

            <Collapse isOpen={!this.state.entityNameSwitch}>

                <Input
                    placeholder={i18n.t('entity_id')}
                    prefix={<IdcardOutlined/>}
                    autoComplete="off"
                    name="entityIdentification"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.entityIdentification}
                />

            </Collapse>
        </>;
    }

    searchByIndividual() {

        const {searchForm} = this.state
        const {minMatchRate, includeLocalSanctions, includePeP, includeAdverseMedia} = searchForm;
        const showLocalSanctions = AuthService.hasRole("LOCAL_LIST");
        const showPeP = AuthService.hasRole("PEP");
        const showAdverseMedia = AuthService.hasRole("ADVERSE_MEDIA");

        return <>
            <div className="mt-20 mb-20">
                <Radio.Group onChange={this.handlePersonNameSwitch} value={this.state.personNameSwitch}>
                    <Radio style={radioStyle} value={true}>
                        {i18n.t('search_by_person_name')}
                    </Radio>
                    <Radio style={radioStyle} value={false}>
                        {i18n.t('search_by_person_id')}
                    </Radio>
                </Radio.Group>
            </div>

            <Collapse isOpen={this.state.personNameSwitch}>

                <Input
                    placeholder={i18n.t('person_name')}
                    prefix={<UserOutlined/>}
                    name="personName"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.personName}
                />

                <Input
                    placeholder={i18n.t('place_of_birth_optional')}
                    prefix={<EnvironmentOutlined/>}
                    autoComplete="off"
                    name="placeOfBirth"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.placeOfBirth}
                />

                <Input
                    placeholder={i18n.t('year_of_birth')}
                    prefix={<ClockCircleOutlined/>}
                    autoComplete="off"
                    name="yearOfBirth"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.yearOfBirth}
                />

                <div className="row search-param-row">
                    <div className="col-sm-12 col-md-4 search-param-label">
                        <span>{i18n.t('minMatchRate')}</span>
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <Slider
                            min={60} max={100}
                            value={minMatchRate}
                            defaultValue={minMatchRate}
                            marks={MATCH_RATE_SLIDER_MARKS}
                            onChange={this.handleMinMatchRate}
                            tipFormatter={minMatchRateFormatter}
                        />
                    </div>
                </div>

                {showLocalSanctions && <div className="row search-param-row">
                    <div className="col-8 col-md-4 search-param-label">
                        <label htmlFor="includeLocalSanctions">{i18n.t("includeLocalSanctions")}</label>
                    </div>
                    <div className="col-4 col-md-8">
                        <Checkbox
                            id="includeLocalSanctions"
                            name="includeLocalSanctions"
                            size="large"
                            checked={includeLocalSanctions}
                            onChange={this.handleIncludeLocalSanctionsChecked}
                        />
                    </div>
                </div>
                }

                {showPeP && <div className="row search-param-row">
                    <div className="col-8 col-md-4 search-param-label">
                        <label htmlFor="includePeP">{i18n.t("includePeP")}</label>
                    </div>
                    <div className="col-4 col-md-8">
                        <Checkbox
                            id="includePeP"
                            name="includePeP"
                            size="large"
                            checked={includePeP}
                            onChange={this.handleIncludePePChecked}
                        />
                    </div>
                </div>
                }

                {showAdverseMedia && <div className="row search-param-row">
                    <div className="col-8 col-md-4 search-param-label">
                        <label htmlFor="includeAdverseMedia">{i18n.t('includeAdverseMedia')}</label>
                    </div>
                    <div className="col-4 col-md-8">
                        <Checkbox
                            id="includeAdverseMedia"
                            name="includeAdverseMedia"
                            size="large"
                            checked={includeAdverseMedia}
                            onChange={this.handleIncludeAdverseMedia}
                        />
                    </div>
                </div>
                }

            </Collapse>

            <Collapse isOpen={!this.state.personNameSwitch}>

                <Input
                    placeholder={i18n.t('person_id')}
                    prefix={<IdcardOutlined/>}
                    autoComplete="off"
                    name="identification"
                    onChange={this.handleInputChange}
                    value={this.state.searchForm.identification}
                />

            </Collapse>
        </>;
    }

}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user,
        search: state.search,
        menu: state.menu
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        searchAction: SearchAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);